// A configuration is the attribute order plus the category order of every attribute:
//   [{ name: "Survived", categories: ["Survived", "Perished"] }, ...]
// This is the form stored in the database. The rendering code (d3.parsets) uses category objects
// ({ name: "Survived" }) instead of strings; normalizeConfig accepts both.

export function normalizeConfig(config) {
    return config.map(attribute => ({
        name: attribute.name,
        categories: attribute.categories.map(c => (typeof c === 'string' ? c : c.name)),
    }));
}

export function serializeConfig(config) {
    return JSON.stringify(normalizeConfig(config));
}

export function deserializeConfig(text) {
    return normalizeConfig(JSON.parse(text));
}

// Form expected by d3.parsets (window.psOrdering).
export function toRenderOrdering(config) {
    return normalizeConfig(config).map(attribute => ({
        name: attribute.name,
        categories: attribute.categories.map(c => ({ name: c })),
    }));
}
